// src/pages/Gallery.js  (GÜNCELLE)
import React, { useMemo, useState, useCallback, useEffect } from "react";
import LightboxCarousel from "../components/LightboxCarousel";
import RAW from "../data/gallery.json";

const FILTERS = [
  { key: "all", label: "Tümü" },
  { key: "saha", label: "Saha" },
  { key: "makine", label: "Makine" },
  { key: "proje", label: "Proje" }
];

// JSON'da poster olmayan videolar için otomatik poster yolu türet (public/media/gallery/posters/{id}.jpg)
function normalize(items) {
  return items.map((p) =>
    p.type === "video"
      ? {
          ...p,
          poster: p.poster || `/media/gallery/posters/${p.id}.jpg`,
        }
      : p
  );
}

export default function Gallery() {
  const [filter, setFilter] = useState("all");
  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(0);

  const ALL = useMemo(() => normalize(RAW), []);
  const list = useMemo(
    () => (filter === "all" ? ALL : ALL.filter((p) => p.category === filter)),
    [filter, ALL]
  );

  const openAt = useCallback((idx) => {
    setIndex(idx);
    setOpen(true);
  }, []);

  const closeLb = useCallback(() => setOpen(false), []);

  // Klavye ile açıldığında ok tuşları carousel'e geçsin
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === "Escape") setOpen(false);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open]);

  return (
    <section className="section">
      <div className="container container-edge"> {/* kenardan kenara */}
        <header className="section-head gallery-head-tight">
          <h1 className="page-title">Galeri</h1>
          <p className="page-subtitle">İş sahası, makine ve proje görselleri.</p>
        </header>

        {/* Masonry - Instagram Keşfet stili */}
        <div className="gallery-masonry">
          {list.map((p, i) => (
            <figure
              key={p.id}
              className="gallery-masonry-item"
              onClick={() => openAt(i)}
            >
              {/* Görsel / Poster */}
              <img
                src={p.type === "video" ? p.poster : (p.thumb || p.full)}
                alt={p.alt || p.title}
                loading="lazy"
                decoding="async"
              />
              {/* Video oynat simgesi overlay */}
              {p.type === "video" && (
                <span className="vid-badge" aria-hidden="true">▶︎</span>
              )}
            </figure>
          ))}
        </div>
      </div>

      {/* Carousel Lightbox */}
      <LightboxCarousel
        open={open}
        onClose={closeLb}
        items={list}
        startIndex={index}
      />
    </section>
  );
}